import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpBaseService } from './http-base.service';

interface ModulePermissions {
  module_name: string;
  actions: string[];
}

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly http = inject(HttpBaseService);
  private readonly permissions = signal<Map<string, string[]>>(new Map());
  private loaded = false;

  load(): Observable<ModulePermissions[]> {
    return this.http.get<ModulePermissions[]>('/permissions/me').pipe(
      tap((perms) => {
        const map = new Map<string, string[]>();
        for (const p of perms ?? []) {
          map.set(p.module_name, p.actions);
        }
        this.permissions.set(map);
        this.loaded = true;
      }),
    );
  }

  hasPermission(module: string, action: string): boolean {
    const actions = this.permissions().get(module);
    return actions?.includes(action) ?? false;
  }

  hasAnyPermission(module: string): boolean {
    return this.permissions().has(module);
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  clear(): void {
    this.permissions.set(new Map());
    this.loaded = false;
  }
}
